<template>
  <div class="contact-page" id="contact-page">
    <ContactSubHeader />
    <ContactFaq />
    <ContactPartners />
    <ContactForm />
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
@use "@/styles/variables" as *;

.contact-page {
  background-color: $purpleLight;
  padding: 54px 20px 0px;

  @media screen and (min-width: 834px) and (max-width: 1199px) {
    padding: 69px 0px 0px;

  }

  @media screen and (min-width: 1200px) {
    padding: 68px 0px 0px;
  }
}
</style>